import { css } from '@linaria/core';
import { COLORS, typographyStyles } from '@livecommerce/design-system';

const { getBodyText } = typographyStyles;

export const labelsCellHoverStyles = css``;
export const labelsHoverStyles = css``;

export const chevronHoverStyles = css``;

export const labelsContainerStyles = css`
  display: flex;
  flex-direction: column;
  min-width: 0;
`;

export const labelStyles = css`
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

export const descriptionStyles = css`
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

export const descriptionActionHover = css`
  cursor: pointer;
`;

export const labelVariationStyles = {
  roman: css`
    ${getBodyText(14, 400)};
  `,
  bold: css`
    ${getBodyText(14)};
  `,
};

export const descriptionVariationStyles = {
  roman: css`
    color: ${COLORS.dark_700};
    ${getBodyText(14, 400)};
  `,
  bold: css`
    color: ${COLORS.dark_300};
    ${getBodyText(12)};
  `,
  romanLight: css`
    color: ${COLORS.dark_300};
    ${getBodyText(12, 400)};
  `,
  danger: css`
    color: ${COLORS.red_400};
    ${getBodyText(12)};
  `,
};

export const labelThemeStyles = {
  dark: css`
    color: ${COLORS.light_100};
  `,
};

export const descriptionThemeStyles = {
  dark: css`
    color: ${COLORS.light_200};
  `,
};
